import {
  IEntryInputGeneric,
  IEntryInputGenericGroup,
  IGenericOptionMap,
  IInputGenericGroup,
  IInputGenericGroupOption
} from '@belong/types';
import { FGenericInput } from './genericInput.factory';

const FGenericInputWithValue = <Values extends string>(
  inputGeneric: IEntryInputGeneric
): IInputGenericGroupOption<Values> => {
  const { description, id, label, key } = FGenericInput(inputGeneric);

  return {
    description,
    id,
    label,
    value: key as Values
  };
};

const FGenericOptionMap = <Keys extends string>(inputOptions: IEntryInputGeneric[]): IGenericOptionMap<Keys> => {
  return inputOptions.reduce((acc, option) => {
    const item = FGenericInput(option);
    return { ...acc, [item.key as Keys]: item };
  }, {} as IGenericOptionMap<Keys>);
};

export function FGenericInputGroup<Keys extends string = '', Values extends string = ''>(
  data: IEntryInputGenericGroup
): IInputGenericGroup<Keys, Values> {
  const { options, groupTitle, key, ...fields } = data.fields;

  const inputOptions = options.map(FGenericInputWithValue<Values>);
  const inputOptionMap = FGenericOptionMap<Keys>(options);

  return {
    id: data.sys.id,
    ...fields,
    legend: groupTitle,
    options: inputOptions,
    optionMap: inputOptionMap
  };
}
